// CriteriaService.js

const API_URL = "/api";

// Save new scoring criteria
export const saveCriteria = async (payload) => {
  console.log(payload);
  const response = await fetch(`${API_URL}/saveScoringCriteria/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Save failed: ${response.status} ${await response.text()}`);
  }

  return response.json();
};
export async function loadAll() {
  const url = `${API_URL}/getScoringCriteriaList`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Load failed: ${res.status}`);

  const all = await res.json();

  return all.map((doc) => {
    const item = Array.isArray(doc.data) ? doc.data[0] : null;
    return {
      _id: doc._id,
      ...item,
    };
  });
}
export async function loadOne(id) {
  const url = `${API_URL}/getScoringCriteriaList`;

  const res = await fetch(url);
  if (!res.ok) throw new Error(`LoadOne failed: ${res.status}`);

  const all = await res.json();
  const doc = all.find((item) => item._id === id);
  return doc?.data?.[0] || null; // ✅ return the real payload
}
